import React from "react";
import { Shield, ArrowLeft } from "lucide-react"; // Removed Clock
import { Link } from "react-router-dom";

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-white py-16 px-4 flex flex-col">
      <div className="max-w-4xl mx-auto w-full">
        {/* Header */}
        <div className="flex flex-col items-center text-center mb-10">
          <div className="w-24 h-24 bg-purple-50 rounded-full flex items-center justify-center mb-6 text-exiser-primary">
            <Shield className="w-12 h-12" />
          </div>
          <h1 className="text-4xl md:text-5xl font-bold uppercase text-gray-900 mb-4 tracking-tight">
            Privacy Policy
          </h1>
          <p className="text-gray-500 font-sans max-w-2xl">
            This Privacy Policy explains how <strong>EXISER PRIVATE LIMITED</strong> 
            (“we”, “us”, “our”) collects, uses, stores, and protects your personal data when 
            you use our website <span className="font-mono">www.exiser.in</span> or any of our 
            training, coaching, events, webinars, or services.
          </p>
        </div>

        <div className="bg-gray-50 rounded-2xl shadow-xl border border-gray-100 p-6 md:p-10 text-left space-y-8">

          {/* 1. Information We Collect */}
          <section>
            <h2 className="text-xl font-bold uppercase text-gray-900 mb-2">
              1. Information We Collect
            </h2>
            <p className="text-gray-700 font-sans">We may collect:</p>
            <ul className="list-disc pl-6 text-gray-700 space-y-1 font-sans">
              <li>Full Name and Email Address</li>
              <li>Payment and transaction information (via secure gateways)</li>
              <li>IP address, device information, browser type, location data</li>
              <li>Course/program participation, event attendance & certification details</li>
              <li>Communication records (email or WhatsApp, if voluntarily provided)</li>
            </ul>
          </section>

          {/* 2. How We Use Your Information */}
          <section>
            <h2 className="text-xl font-bold uppercase text-gray-900 mb-2">
              2. How We Use Your Information
            </h2>
            <p className="text-gray-700 font-sans">We may use your data to:</p>
            <ul className="list-disc pl-6 text-gray-700 space-y-1 font-sans">
              <li>Process registrations, course access, and certifications</li>
              <li>Send important service updates, confirmations, and reminders</li>
              <li>Improve website functionality, analytics, and user experience</li>
              <li>Enhance training personalization and performance tracking</li>
              <li>Comply with legal, financial, or security obligations</li>
            </ul>
          </section>

          {/* 3. Data Sharing */}
          <section>
            <h2 className="text-xl font-bold uppercase text-gray-900 mb-2">
              3. Data Sharing
            </h2>
            <p className="text-gray-700 font-sans">
              We <strong>do not sell or trade your personal data.</strong>  
              Limited sharing may occur with:
            </p>
            <ul className="list-disc pl-6 text-gray-700 space-y-1 font-sans">
              <li>Trusted payment processing partners</li>
              <li>Learning platforms and secure cloud services</li>
              <li>Legal or regulatory authorities (only when required)</li>
            </ul>
          </section>

          {/* 4. Cookies */}
          <section>
            <h2 className="text-xl font-bold uppercase text-gray-900 mb-2">
              4. Cookies & Tracking
            </h2>
            <p className="text-gray-700 font-sans">
              We use cookies to improve performance, remember preferences, and analyze 
              website usage. You may disable cookies through browser settings, but some 
              features may not function properly.
            </p>
          </section>

          {/* 5. Security */}
          <section>
            <h2 className="text-xl font-bold uppercase text-gray-900 mb-2">
              5. Data Security
            </h2>
            <p className="text-gray-700 font-sans">
              We use encryption, access control, and secure hosting—but no system 
              is 100% secure. By using our Website, you accept this inherent risk.
            </p>
          </section>

          {/* 6. Data Retention */}
          <section>
            <h2 className="text-xl font-bold uppercase text-gray-900 mb-2">
              6. Data Retention
            </h2>
            <p className="text-gray-700 font-sans">
              We retain data only as long as necessary for service delivery, 
              compliance, or certification record purposes.
            </p>
          </section>

          {/* 7. Your Rights */}
          <section>
            <h2 className="text-xl font-bold uppercase text-gray-900 mb-2">
              7. Your Rights
            </h2>
            <p className="text-gray-700 font-sans">You may request to:</p>
            <ul className="list-disc pl-6 text-gray-700 space-y-1 font-sans">
              <li>Access, correct, or update your data</li>
              <li>Request data deletion (where legally permitted)</li>
              <li>Withdraw consent for marketing communications</li>
            </ul>
            <p className="text-gray-700 font-sans">
              To exercise these rights, email us at:{' '}
              <a
                href="mailto:support@exiser.in"
                className="text-exiser-primary font-medium hover:text-exiser-accent"
              >
                support@exiser.in
              </a>
            </p>
          </section>

          {/* 8. Policy Updates */}
          <section>
            <h2 className="text-xl font-bold uppercase text-gray-900 mb-2">
              8. Policy Updates
            </h2>
            <p className="text-gray-700 font-sans">
              This policy may be updated periodically. We encourage users to 
              review this page regularly.
            </p>
          </section>

          {/* Footer Legal Version */}
          <section>
            <h2 className="text-xl font-bold uppercase text-gray-900 mb-2">
              9. Footer Legal Pack (Summary)
            </h2>
            <p className="text-gray-700 font-sans italic">
              By using this Website, you agree to our{' '}
              <strong>Terms & Conditions, Privacy Policy, Refund Policy, Disclaimer, and Cookie Policy.</strong>
            </p>
          </section>

          {/* Contact */}
          <section>
            <h2 className="text-xl font-bold uppercase text-gray-900 mb-2">
              10. Contact Information
            </h2>
            <p className="text-gray-700 font-sans">
              For privacy-related requests, please contact:
            </p>
            <div className="border-l-4 border-exiser-primary pl-4">
              <p className="font-semibold">EXISER PRIVATE LIMITED</p>
              <p>
                Email:{' '}
                <a
                  href="mailto:support@exiser.in"
                  className="text-exiser-primary hover:text-exiser-accent font-medium"
                >
                  support@exiser.in
                </a>
              </p>
            </div>
          </section>
        </div>

        {/* Back to Home */}
        <div className="mt-10 flex justify-center">
          <Link
            to="/"
            className="flex items-center gap-2 text-exiser-primary font-bold uppercase hover:text-exiser-accent transition-colors group"
          >
            <ArrowLeft className="w-4 h-4 group-hover:-translate-x-1 transition-transform" />
            Return Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;